import { StateInterface } from "./state";
import { InvoiceModel, AccessLogUserModel } from "../models";

export const setInvoicesHandle = "setInvoices";
export const setAccessLogsHandle = "setAccessLogs";

export default {
  [setInvoicesHandle](state: StateInterface, invoices: InvoiceModel[]): void {
    state.invoices = invoices;
  },
  [setAccessLogsHandle](
    state: StateInterface,
    accessLogs: AccessLogUserModel[]
  ): void {
    state.accessLogs = accessLogs;
  }
};
